import React from "react";
import { useNavigate } from "react-router-dom"; // Hook para manejar la navegación
import "./CategoriesSection.css"; // Archivo CSS actualizado
import merchandizingImage from "../assets/merchandizing.jpg";
import snowImage from "../assets/snow.jpg";
import hogarImage from "../assets/hogar.jpg";

const CategoriesSection = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate(`/productos?category=${category}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const categories = [
    { name: "Merchandising", image: merchandizingImage },
    { name: "Snow", image: snowImage },
    { name: "Hogar", image: hogarImage },
  ];

  return (
    <div className="unique-categories-container">
      <div className="unique-categories-section">
        <h2 className="unique-text-center">Categorías</h2>
        <div className="unique-container">
          <div className="unique-row">
            {categories.map((category, index) => (
              <div
                className="unique-col"
                key={index}
                onClick={() => handleCategoryClick(category.name)}
                style={{ cursor: "pointer" }}
              >
                <div className="unique-category-card">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="unique-category-image"
                  />
                  <div className="unique-category-overlay">
                    <h3 className="unique-category-title">{category.name}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesSection;
